import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { isNumberOrCSVOfNumbers, splitData } from '@helios/utils'
import { ErrorMessage } from '@northfork/ng-basics'

const INVALID_ID_KEY = 'INVALID_ID'

/**
 * FormControl validator to check if the form control value exceeds the hold limit in days.
 */
export function IdOrListValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == undefined || control.value == '') {
      return null
    }

    const value = control.value as string

    if (isNumberOrCSVOfNumbers(value)) {
      return null
    }

    return {
      [INVALID_ID_KEY]: {
        value,
      },
    }
  }
}

const idOrListOfIdsValidationMessages: ErrorMessage[] = [
  {
    error: INVALID_ID_KEY,
    format: () => `Expected a number or a list of numbers.`,
  },
]

export const IdOrListOfIdsValidationMessages = {
  idOrListOfIdsValidationMessages,
}

/**
 * FormControl validator to check if the form control value is number or list of number comma or space separated.
 */
export function NumberOrListValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value as string
  if (!value) return null

  const valueArray = splitData(value).map(Number)
  return valueArray.every(Number.isFinite) ? null : { invalidNumber: true }
}

/**
 * FormControl validator to check if the form control value is not a space separated value.
 */
export function CommaSeparatedValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value as string
  if (!value) return null

  // regex to check any whitespace that is not immediately after a comma

  const regex = /(?<!,)\s/
  if (regex.test(value)) return { spaceSeparatedError: true }
  else return null
}

/**
 * FormControl validator to check if the form control value is a space or comma separated value.
 */
export function StringOrListValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value as string
  if (!value) return null

  const valueArray = splitData(value).map(String)
  return valueArray.every(String) ? null : { invalidString: true }
}
